import { render, staticRenderFns } from "./PlayMatch.vue?vue&type=template&id=8118ad7e&scoped=true&"
import script from "./PlayMatch.vue?vue&type=script&lang=js&"
export * from "./PlayMatch.vue?vue&type=script&lang=js&"
import style0 from "./PlayMatch.vue?vue&type=style&index=0&id=8118ad7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8118ad7e",
  null
  
)

export default component.exports